import { useCallback, useEffect, useRef } from 'react';
import { Transition } from 'history';
import { useNavigationPrompt } from 'contexts';
import useBlocker from './useBlocker';
import useSetHasDirtyForm from './useSetHasDirtyForm';

export default function usePrompt(message: string, when = true) {
  useSetHasDirtyForm(when);
  const confirm = useNavigationPrompt();
  const whenRef = useRef(when);
  whenRef.current = when;

  const blocker = useCallback(
    (tx: Transition) => {
      if (!whenRef.current) {
        tx.retry();
        return;
      }

      confirm(message).then((confirmed) => {
        if (confirmed) tx.retry();
      });
    },
    [confirm, message],
  );

  const promptBeforeUnload = useCallback(
    (e: BeforeUnloadEvent) => {
      if (when) {
        e.preventDefault();
        e.returnValue = message;
      }
    },
    [message, when],
  );

  useEffect(() => {
    window.addEventListener('beforeunload', promptBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', promptBeforeUnload);
    };
  }, [promptBeforeUnload]);

  useBlocker(blocker, when);
}
